import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { openConstructor } from '../AddCreativePage/actions';
import { CanvasAction } from '../common/actions';
import { Page } from '../common/typings';

import { fetchIdeas, ideasUrlChange } from './actions';
import { IdeasList, IdeasListProps } from './IdeasList';

export type StateProps = TStateProps<IdeasListProps>;

export type DispatchProps = TDispatchProps<IdeasListProps>;

const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>): DispatchProps => {
    return {
        onUrlChange: (url: string) => {
            dispatch(ideasUrlChange(url));
        },
        onUrlSubmit: (url: string) => {
            dispatch(fetchIdeas({ url }));
        },
        fetchIdeas: (ideaId: string) => {
            dispatch(fetchIdeas({ ideaId }));
        },
        selectIdea: (ideaId: string, presetId: number, isAdaptive?: boolean) => {
            dispatch(openConstructor(Page.IDEAS, String(presetId), undefined, ideaId, isAdaptive));
        }
    };
};

export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.canvas.ideasList;
};

export const IdeasListContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(IdeasList);
